import { Fragment, useContext, useState } from "react";
import { UBButton, ParagraphText, HeadingText } from "../../../../Libraries";
import { TitleAndActionBox } from "../../../common";
import { Box, Grid } from "@mui/material";
import { LanguageContext } from "../../../../context/LanguageContext";
import formStyles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import { useNavigate } from "react-router-dom";
import { formatNum } from "../../../../oscar-pos-core/constants";
import BusinessLoader from "../../../common/BusinessLoader";
import { PhoneIcon } from "../../../../assets/icons/icon";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./AccountLimitOverview.module.css";
import ChatwootWidget from "../../../common/Chatwoot";
import { openChatwootWindow } from "../../../../utils/chatwoot";
import { useAuthContext } from "../../../../context/AuthContext";

const getResetDate = (renew_in) => {
  const date = new Date();
  date.setDate(date.getDate() + (renew_in || 0));
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

const AccountLimitOverview = ({
  accountLimit,
  loadingAccountLimit,
  increaseButtonDisable,
  onIncreaseLimit,
}) => {
  const [I18n] = useContext(LanguageContext);
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [isChatWidgetOpen, setIsChatWidgetOpen] = useState(false);

  const { remaining_amount = 0, total_amount = 0, used_amount = 0, renew_in } =
    accountLimit || {};

  const handleCall = () => {
    triggerLogEvent(analytics, "w_acc_limit_call_click");
    window.location.href = "tel:+923420191000";
  };

  const handleWhatsapp = () => {
    triggerLogEvent(analytics, "w_acc_limit_whatsapp_click");
    setIsChatWidgetOpen(true);
    openChatwootWindow();
  };

  return (
    <Fragment>
      {isChatWidgetOpen ? <ChatwootWidget user={user} /> : null}
      <BusinessLoader loadBusiness={loadingAccountLimit} />
      <Grid
        container
        className={`${formStyles.root} ${formStyles.SaleExpenseFormWrapper} ${styles.wrapper} accountLimitScreen`}
      >
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: "account_limit",
              isBack: true,
              onBack: () => navigate(-1),
              id: "account_limit",
            }}
          />
          <Box className={formStyles.formBodyGrid}>
            <Box className={formStyles.formColumn}>
              <Box className={`${formStyles.formBody} ${styles.formBody}`}>
                <HeadingText
                  className={`fontSize24 fontWeight500 ${styles.pageTitle}`}
                >
                  {I18n.account_limit}
                </HeadingText>

                <Box className={styles.card}>
                  <ParagraphText
                    className={`fontSize14 newFontColor ${styles.totalLimitLabel}`}
                  >
                    {I18n.total_limit}
                  </ParagraphText>
                  <ParagraphText
                    className={`fontSize24 fontWeight600 ${styles.totalLimitAmount}`}
                  >
                    {`Rs. ${formatNum(total_amount || 0)}`}
                  </ParagraphText>
                  <ParagraphText
                    className={`fontSize14 newLightColor ${styles.resetDate}`}
                  >
                    {`${I18n.resets_on} ${getResetDate(renew_in)}`}
                  </ParagraphText>

                  <Box className={styles.bottomSection}>
                    <Box className={styles.row}>
                      <ParagraphText className="fontSize14 newLightColor">
                        {I18n.used}
                      </ParagraphText>
                      <ParagraphText className="fontSize14 newFontColor">
                        {`Rs. ${formatNum(used_amount || 0)}`}
                      </ParagraphText>
                    </Box>
                    <Box className={styles.row}>
                      <ParagraphText className="fontSize14 newLightColor">
                        {I18n.remaining}
                      </ParagraphText>
                      <ParagraphText className="fontSize14 newFontColor">
                        {`Rs. ${formatNum(remaining_amount || 0)}`}
                      </ParagraphText>
                    </Box>
                  </Box>
                </Box>

                <UBButton
                  id="account_limit_increase_btn"
                  disabled={increaseButtonDisable}
                  title={I18n.increase_limit}
                  className={`buttonPrimary saveSaleButton textUppercase ${styles.increaseButton}`}
                  onClick={onIncreaseLimit}
                />

                {increaseButtonDisable ? (
                  <Box className={styles.helpSection}>
                    <ParagraphText className={`fontSize14 ${styles.helpText}`}>
                      {I18n.limit_increase_request_in_process_need_help}
                    </ParagraphText>
                    <Box className={styles.helpCTA}>
                      <UBButton
                        id="opt_call_btn"
                        iconComponent={<PhoneIcon width={18} height={18} />}
                        className="ubSecondaryButton"
                        title={I18n.call}
                        onClick={handleCall}
                      />
                      <UBButton
                        id="opt_chat_btn"
                        className="ubSecondaryButton"
                        title={I18n.chat_with_us}
                        onClick={handleWhatsapp}
                      />
                    </Box>
                  </Box>
                ) : null}
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default AccountLimitOverview;
